// extracted by mini-css-extract-plugin
module.exports = {"Tooltip":"Tooltip_Tooltip__2s4f5","show":"Tooltip_show__UIeI5"};